import React, { useMemo, useCallback, useState, useEffect } from "react";
import {
  PostFieldLabel,
  PostFieldCounter,
  PlatformUsage,
} from "components/Posts/PostForm";
import { FIELDS } from "constants/PostFormFields";
import { useDebouncedCallback } from "use-debounce";
import { TextInput } from "ui/ecosystems/forms/inputs";

const YouTubeTitle = ({
  url,
  post,
  field,
  checkSetting = false,
  selectedPlatform,
  selectedAccounts,
  platforms,
  title,
  className = "",
  onChange,
  disabled = false,
}) => {
  const [value, setValue] = useState("");
  useEffect(() => {
    if (post["ytTags"]) {
      setValue(post["ytTags"]);
    }
  }, []);

  const bounce = useDebouncedCallback((value) => {
    let title = post["ytTags"];
    if (value != title) {
      onChange(value);
    }
  }, 200);

  return (
    <div className={className}>
      <div className="flex flex-col mb-4">
        <div className="flex items-center mb-2 ">
          <PostFieldLabel className="mr-2">{title}</PostFieldLabel>
          <PlatformUsage
            platforms={platforms}
            field={FIELDS.YT_TAGS}
            selectedPlatform={selectedPlatform}
          />
        </div>
        <TextInput
          value={value}
          placeholder="cat, dog, rabbit, …"
          disabled={disabled}
          onChange={(value) => {
            const newVal = value;
            setValue(newVal);
            bounce(newVal);
          }}
        />
        <PostFieldCounter
          count={value.length}
          max={400}
          className="flex-grow text-right mt-2 mr-8"
        >
          Characters
        </PostFieldCounter>
      </div>
    </div>
  );
};

export default YouTubeTitle;
